import { AxiosInstance } from 'axios';
import baseAxios from '@/helpers/forms/axios';
import { DataFetcherFunction } from '../../compiler/types';
import exports from './exports';
import { ExportOperation } from './exports';

export interface MetabaseReportParameter {
    name: string
    value: string | number | null | false
}

export interface MetabaseReport {
    id: string
    category: string
    name: string
    description: string
    merchantFilterable: boolean
    defaultParams: MetabaseReportParameter[]
};

export default (axios: AxiosInstance = baseAxios): { getServiceProviderReportEmbedUrl: (reportId: string, params: MetabaseReportParameter[]) => Promise<string>; exports: { getOperations: DataFetcherFunction<ExportOperation>; fetchOperation: (operationId: string) => Promise<ExportOperation>; getDownloadUrlForOperation: (operationId: string) => Promise<string>; exportInventoryItems: () => Promise<ExportOperation>; exportCharges: () => Promise<ExportOperation>; exportChargeItems: (chargeId?: number | null) => Promise<ExportOperation>; exportListings: (channelId: number) => Promise<ExportOperation>; }; } => ({
    getServiceProviderReportEmbedUrl: async (reportId: string, params: MetabaseReportParameter[]): Promise<string> => {
        const reportParams: { [key: string]: string | number | null | false } = {};
        if (params.length) {
            params.forEach((param) => {
                reportParams[param.name] = param.value;
            });
        }

        const response = await axios.post<{ url: string }>('/api/reports/service-providers/embed', {
            reportId,
            reportParams,
        });

        return response.data.url;
    },

    exports: exports(axios),
});
